import {createApp} from 'vue'
import serviceWestern from '../views/ServiceWestern.vue'

import '@fortawesome/fontawesome-free/css/all.css'
import "../scss/index.scss";
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';


createApp(serviceWestern).mount("#app");
